export const lightTheme = {
  mode: "light",
  body: "#ffffff",
  text: "#000000",
  elementBg: "#f5fbfd",
  cardBg: "#ffffff",
  loginBg:
    "linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), center",
};

export const darkTheme = {
  mode: "dark",
  body: "linear-gradient(#2a2a2a, #1e1e1e)",
  text: "#f5f5f5",
  elementBg: "#2a2a2a",
  cardBg: "#333333",
  loginBg:
    "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), center",
};
